/**
 * Geography Service - US states and cities lookup
 */

import apiClient from './apiClient';

export interface UsState {
  state: string;
  stateCode: string;
}

export interface UsCity {
  id: number;
  city: string;
  state: string;
  stateCode: string;
  county: string | null;
}

export const getStates = async (): Promise<UsState[]> => {
  const response = await apiClient.get<{ success: boolean; data: UsState[] }>(
    '/api/v1/geography/states',
  );
  return response.data.data;
};

export const getCities = async (
  params: { stateCode?: string; search?: string } = {},
): Promise<UsCity[]> => {
  const response = await apiClient.get<{ success: boolean; data: UsCity[] }>(
    '/api/v1/geography/cities',
    { params },
  );
  return response.data.data;
};

const geographyService = { getStates, getCities };
export default geographyService;
